import type { IAsset } from '@netx/core-asset-next/schema';
import {currentUserMeetsUserLevel, UserLevel} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {assetPermissionChecker, PermissionMatrixName, PermissionName} from '@netx/core-permissions-next/utils/assetPermissionChecker';

export const canDownloadConstituentClip = (asset?: IAsset): boolean => {
    if (!asset) return false;
    if (!currentUserMeetsUserLevel(UserLevel.PRODUCER)) return false;
    return assetPermissionChecker({
        asset,
        permissionMatrixName: PermissionMatrixName.DOWNLOAD,
        permissionName: PermissionName.DOWNLOAD,
    });
};
